'use client';

import React from 'react';
import { useRouter, usePathname, useSearchParams } from 'next/navigation';
import Button from '../Button';
import s from './ExitPreviewButton.module.scss';

interface ExitPreviewButtonProps {
  onExit?: () => void;
}

export default function ExitPreviewButton({ onExit }: ExitPreviewButtonProps): React.JSX.Element {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const currentPath = searchParams?.toString()
    ? `${pathname}?${searchParams.toString()}`
    : pathname;

  const handleExitPreviewClick = () => {
    onExit?.();
    router.push(`/exit-preview?path=${encodeURIComponent(currentPath || '/')}`);
    router.refresh();
  };

  return (
    <Button variant='dark' className={s.rootExitPreview} onClick={handleExitPreviewClick}>
      Exit Preview
    </Button>
  );
}
